import ViewManualOrdersContainer from './view-manual-orders-container';

export default ViewManualOrdersContainer;
